import { call, put, takeLatest } from 'redux-saga/effects';
import { authenticatedCall } from '../utils/authenticated-call';
import {
  errorUserAction, setTbRegistrationSuccess, tbRegistrationAction, userSetDataAction
} from '../store/user.store';
import { meAPI, tbRegistrationAPI } from '../api/provider/auth/auth-provider';
import { ApiResponse } from '../api/request';


function* TbRegistrationSaga() {

  try {
    yield authenticatedCall(tbRegistrationAPI);
    yield put(setTbRegistrationSuccess())
    let meResult: ApiResponse | null = null
    meResult = yield call(meAPI)
    yield put(userSetDataAction(meResult?.data.data))
  } catch (error: any) {
    yield put(errorUserAction(error.localizedMessage));
  }
}

export function* TbRegistrationSagas() {
  yield takeLatest(tbRegistrationAction.type, TbRegistrationSaga);
}
